import { getActiveScene } from 'js/shared/helpers/scenesHelpers';
import { ExistingScribeModel } from 'js/types';

export const getActiveSceneIds = (scribe: ExistingScribeModel, sceneIds?: string[]) => {
  if (sceneIds && sceneIds.length > 0) {
    return sceneIds;
  }

  const activeScene = getActiveScene(scribe);

  if (!activeScene) {
    return undefined;
  }

  return [activeScene.id];
};
